import { Box } from '@mui/material';
import React from 'react';
import Hero from '../../components/Hero/Hero';
import Metadata from '../../components/Metadata/Metadata';
import Form from './Form/Form';

const PageContent: React.FC = () => {
  return (
    <Box>
      <Metadata
        title="Contact Us | General Genomics"
        description="Get in touch with General Genomics for inquiries, demos, and business opportunities. Our Contact page makes it easy to connect and take the next step in your journey."
      />
      <Hero helper="Contact Us" headline="Get in touch with General Genomics" />
      <Form />
    </Box>
  );
};

export default PageContent;
